import {FIELDS_CODE} from "../../actions/Constants";
import CustomCheckbox from "../CustomCheckbox";
import React, {useState} from "react";
import {connect} from "react-redux";

const VideoSizeRadioButton = ({
  formErrors,
  state,
  lengthindex,
  onChange,
  option
}) => {
    let [videoSizeType, setVideoSizeType] = useState(null);
    const handleChange = (info) => {
        console.log('info', info);
        let fieldCode = info['field-code'];
        let cutLength = state.cutLength;
        let code = info.code;
        let videoSizeStateValue = null;
        if(fieldCode === 'video_size') {
            for(let indexCutLength in cutLength) {
                console.log('cutLength', cutLength, indexCutLength);
                if(videoSizeType === 'radio') {
                    cutLength[indexCutLength]['video_size'] = code;
                } else {
                    if(!cutLength[indexCutLength]?.video_size) {
                        cutLength[indexCutLength] = {
                            ...cutLength[indexCutLength],
                            video_size: {
                                [code]: true
                            }
                        }
                    } else {
                        cutLength[indexCutLength].video_size = {
                                ...cutLength[indexCutLength].video_size,
                                [code]: !cutLength[indexCutLength].video_size[code]
                        }
                    }
                }
                videoSizeStateValue = cutLength[indexCutLength].video_size;
            }
            state['video_size'] = videoSizeStateValue;
        }
        console.log('videoSizeStateValue', videoSizeStateValue)
        onChange(state)
    }
    const isChecked = (sku) => {
        let type = getVideoSizeOptionType();
        console.log('isChecked', type, state['video_size'], state[sku])
        if(type === 'radio') {
            return sku === state['video_size'];
        }
        if(state?.video_size) {
            return state?.video_size[sku];
        }
        return false;
    }

    const getVideoSizeOptionType = () => {
        let type = '';
        if(videoSizeType) {
            return videoSizeType
        }
        if(option?.type && (option.type === "drop_down" || option.type === "radio")) {
            type = 'radio'
        } else {
            type = "checkbox"
        }
        setVideoSizeType(type);
        return type;
    }

    return <div className="form-group">
        <div className="row mt-40 mb-20">
            <div className="col-xs-12">
                <label className="white">Video Size:</label>
            </div>
        </div>
        {formErrors.indexOf(FIELDS_CODE.video_size.code) !== -1 &&
          <div className="col-xs-12 mb-20">
              <div className="alert error">
                  <p>Please select a Video Size from the options below.</p>
              </div>
          </div>
        }
        <div className="row mb-20">
            <div className="col-md-3 col-sm-6 mb-20">
                <ul>
                    <li className="mb-10">
                        <label>
                            <CustomCheckbox
                              type={getVideoSizeOptionType()}
                              name={FIELDS_CODE.video_size.code + lengthindex}
                              checked={isChecked("16x9_horizontal")}
                              label={'16x9 Horizontal'}
                              onchange={handleChange}
                              feedBackInfo={{
                                  value: state?.cutLength['16x9_horizontal'],
                                  code: '16x9_horizontal',
                                  'field-code': 'video_size'
                              }}
                            />
                        </label>
                    </li>
                    <li className="mb-10">
                        <label>
                            <CustomCheckbox
                              type={getVideoSizeOptionType()}
                              name={FIELDS_CODE.video_size.code + lengthindex}
                              checked={isChecked("1x1_square")}
                              label={'1x1 Square'}
                              onchange={handleChange}
                              feedBackInfo={{
                                  value: FIELDS_CODE.video_size.sku["9x16_vertical_story"],
                                  code: FIELDS_CODE.video_size.sku["1x1_square"],
                                  'field-code': 'video_size'
                              }}
                            />
                        </label>
                    </li>
                    <li className="mb-10">
                        <label>
                            <CustomCheckbox
                              type={getVideoSizeOptionType()}
                              name={FIELDS_CODE.video_size.code + lengthindex}
                              checked={isChecked("9x16_vertical_story")}
                              label={'9:16 Vertical/Story'}
                              onchange={handleChange}
                              feedBackInfo={{
                                  value: FIELDS_CODE.video_size.sku["9x16_vertical_story"],
                                  code: FIELDS_CODE.video_size.sku["9x16_vertical_story"],
                                  'field-code': 'video_size'
                              }}
                            />
                        </label>
                    </li>
                    <li className="mb-10">
                        <label>
                            <CustomCheckbox
                              type={getVideoSizeOptionType()}
                              name={FIELDS_CODE.video_size.code + lengthindex}
                              checked={isChecked("4x5_vertical")}
                              label={'4:5 Vertical'}
                              onchange={handleChange}
                              feedBackInfo={{
                                  value: FIELDS_CODE.video_size.sku["4x5_vertical"],
                                  code: FIELDS_CODE.video_size.sku["4x5_vertical"],
                                  'field-code': 'video_size'
                              }}
                            />
                        </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
}
export default connect(null, null)(VideoSizeRadioButton)
